var map = {
	"./decidim/avatar-multiuser.png": 1891,
	"./decidim/brands/facebook.svg": 2763,
	"./decidim/brands/google.svg": 32386,
	"./decidim/brands/twitter-x.svg": 55043,
	"./decidim/cc-badge.png": 5217,
	"./decidim/decidim-logo.svg": 97329,
	"./decidim/default-avatar.svg": 64465,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 40391,
	"./decidim/icons.svg": 8176,
	"./decidim/pattern.png": 371,
	"./decidim/placeholder-card-g.svg": 71120,
	"./decidim/placeholder-card-l.svg": 11803,
	"./decidim/placeholder.jpg": 1426,
	"./decidim/remixicon.symbol.svg": 6536,
	"./decidim/vendor/social-share-button/douban.svg": 80475,
	"./decidim/vendor/social-share-button/email.svg": 43700,
	"./decidim/vendor/social-share-button/facebook.svg": 31120,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 27588,
	"./decidim/vendor/social-share-button/hacker_news.svg": 48472,
	"./decidim/vendor/social-share-button/linkedin.svg": 12402,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 3803,
	"./decidim/vendor/social-share-button/pinterest.svg": 15698,
	"./decidim/vendor/social-share-button/reddit.svg": 33512,
	"./decidim/vendor/social-share-button/telegram.svg": 21213,
	"./decidim/vendor/social-share-button/tumblr.svg": 62906,
	"./decidim/vendor/social-share-button/twitter.svg": 24081,
	"./decidim/vendor/social-share-button/vkontakte.svg": 88123,
	"./decidim/vendor/social-share-button/wechat.svg": 21446,
	"./decidim/vendor/social-share-button/whatsapp.svg": 57534,
	"./decidim/vendor/social-share-button/x.svg": 3148,
	"./decidim/vendor/social-share-button/xing.svg": 76364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20332;